import { render, staticRenderFns } from "./ManifestImportPreview.vue?vue&type=template&id=2b3413ea&scoped=true"
import script from "./ManifestImportPreview.vue?vue&type=script&lang=js"
export * from "./ManifestImportPreview.vue?vue&type=script&lang=js"
import style0 from "./ManifestImportPreview.vue?vue&type=style&index=0&id=2b3413ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3413ea",
  null
  
)

export default component.exports